import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import BaseDialog from 'core/components/base-dialog';

import { Label } from 'core/components/label';
import useStyles from './warning-modal.styles';

const reasonsData = {
  BRANDED_TITLE_CAR_ADDED: {
    title: 'Please review coverages on the vehicle(s) you just added',
    description:
      'This/These vehicle(s) only qualifies for liability coverage with Branch because our title data sources indicate that they were rebuilt, restored, or were a manufacturer lemon buyback. Any selections for comprehensive or collision deductibles, roadside, loan/lease, rental coverage, rideshare coverage, or additional custom parts, will be removed. Please review these changes before continuing to other changes.'
  },
  BRANDED_TITLE_COMP_COLL_RESTRICTED: {
    title: 'Please review coverages on the vehicle(s) you just added',
    description:
      'This/These vehicle(s) has a branded title and only comprehensive and collision deductibles will be reset to "No Coverage". Other coverages such as roadside, rental, rideshare, and additional custom parts will remain as selected. An additional override is required to enable comprehensive and collision. Please review these changes before continuing to other changes.'
  },
  // Shown when an agent previews a "Create New Change" on a date that already has a change on it
  // (#31068). Recoverable by design — closing returns to the form with the draft intact, so the
  // agent can pick a different date or switch to "Edit Selected Change".
  CHANGE_DATE_CONFLICT: {
    title: 'Change date conflict',
    description:
      'A change already exists for this effective date. To continue, choose a different date or switch to "Edit Selected Change" to update the existing change.'
  }
};

function WarningModal({ onClose, open, reason }) {
  const classes = useStyles();
  const { title, description } = reasonsData[reason];
  return (
    <BaseDialog size="lg" open={open}>
      <div className={classes.container}>
        <Label className={classes.title} type="greenBig">
          {title}
        </Label>
        <Label type="body1">{description}</Label>
        <div className={classes.footer}>
          <Button className={classes.button} variant="contained" color="primary" type="button" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </BaseDialog>
  );
}

WarningModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  reason: PropTypes.string.isRequired
};

export default WarningModal;
